// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menuContainer--2ATYpswp {\n  overflow: auto;\n}\n  .menuContainer--2ATYpswp .ant-menu {\n    min-height: 100%;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": "menuContainer--2ATYpswp"
};
export default ___CSS_LOADER_EXPORT___;
